import casper from "images/home-v2/brand-logos/casper-logo.svg";
import cosmopolitan from "images/home-v2/brand-logos/cosmopolitan-logo.svg";
import dailyHarvest from "images/home-v2/brand-logos/daily-harvest-logo.svg";
import generalAssembly from "images/home-v2/brand-logos/general-assembly-logo.svg";
import harpersBazaar from "images/home-v2/brand-logos/harper-s-bazaar-logo.svg";
import harperCollins from "images/home-v2/brand-logos/harpercollins-logo.svg";
import hearst from "images/home-v2/brand-logos/hearst-logo.svg";
import theChive from "images/home-v2/brand-logos/the-chive-logo.svg";
import theSkimm from "images/home-v2/brand-logos/the-skimm-logo.svg";
import wellpath from "images/home-v2/brand-logos/wellpath-logo.svg";
import wineAwesomeness from "images/home-v2/brand-logos/wine-awesomeness-logo.svg";
import forbes from "images/login/homepage/press-logos/forbes-logo.png";

/**
 * @typedef {Object} BrandLogo
 * @property {string} src - imported SVG URL
 * @property {string} alt - alt text
 */

/** @type {BrandLogo[]} */
export const brandLogos = [
  { src: hearst, alt: "Hearst" },
  { src: forbes, alt: "Forbes" },
  { src: cosmopolitan, alt: "Cosmopolitan" },
  { src: casper, alt: "Casper" },
  { src: dailyHarvest, alt: "Daily Harvest" },
  { src: generalAssembly, alt: "General Assembly" },
  { src: harpersBazaar, alt: "Harper's Bazaar" },
  { src: harperCollins, alt: "HarperCollins" },
  { src: theChive, alt: "The Chive" },
  { src: theSkimm, alt: "The Skimm" },
  { src: wellpath, alt: "Wellpath" },
  { src: wineAwesomeness, alt: "Wine Awesomeness" },
];
